(function() {
  const TGLProduct = window.TGLProduct = window.TGLProduct || {};
  const SELECTORS = TGLProduct.SELECTORS;
  const CLASSNAMES = TGLProduct.CLASSNAMES;

  function getVariantImages(data, variant) {
    const fromMetafield = (data.variantGalleries && data.variantGalleries[variant.id]) || [];
    if (fromMetafield.length) return fromMetafield;

    if (variant.featured_image && variant.featured_image.src) {
      const src = variant.featured_image.src;
      return [
        {
          src,
          thumb: TGLProduct.resizeShopifyImage(src, 150),
          medium: TGLProduct.resizeShopifyImage(src, 800)
        }
      ];
    }

    return [];
  }

  function updateNavState(ctx) {
    const hasMultiple = Array.isArray(ctx.galleryImages) && ctx.galleryImages.length > 1;
    [ctx.galleryPrev, ctx.galleryNext].forEach((button) => {
      if (!button) return;
      button.disabled = !hasMultiple;
    });
    if (ctx.galleryIndicators) {
      ctx.galleryIndicators.hidden = !hasMultiple && (!ctx.galleryImages || !ctx.galleryImages.length);
    }
  }

  function updateIndicatorState(ctx) {
    if (!ctx.galleryIndicators) return;
    ctx.galleryIndicators
      .querySelectorAll('[data-gallery-indicator]')
      .forEach((indicator) => {
        const isActive = Number(indicator.dataset.galleryIndicator || 0) === ctx.activeImageIndex;
        indicator.classList.toggle('gallery-indicator--active', isActive);
      });
  }

  function setGalleryLoading(ctx, value) {
    if (!ctx.galleryMain) return;
    ctx.galleryMain.classList.toggle('is-loading', Boolean(value));
  }

  function setMainImage(ctx, mediumSrc, fullSrc) {
    if (!ctx.mainImage || !mediumSrc) return;

    if (ctx._imageLoadHandler) {
      ctx.mainImage.removeEventListener('load', ctx._imageLoadHandler);
      ctx.mainImage.removeEventListener('error', ctx._imageLoadHandler);
    }

    const handleLoad = () => {
      setGalleryLoading(ctx, false);
      if (ctx._imageLoadHandler) {
        ctx.mainImage.removeEventListener('load', ctx._imageLoadHandler);
        ctx.mainImage.removeEventListener('error', ctx._imageLoadHandler);
        ctx._imageLoadHandler = null;
      }
    };

    ctx._imageLoadHandler = handleLoad;
    setGalleryLoading(ctx, true);
    ctx.mainImage.addEventListener('load', handleLoad);
    ctx.mainImage.addEventListener('error', handleLoad);
    ctx.mainImage.src = mediumSrc;
    if (fullSrc) {
      ctx.mainImage.setAttribute('data-large-image', fullSrc);
    }

    if (ctx.mainImage.complete && ctx.mainImage.naturalWidth) {
      handleLoad();
    }
  }

  function bindIndicatorClicks(ctx) {
    if (!ctx.galleryIndicators) return;
    ctx.galleryIndicators.querySelectorAll('[data-gallery-indicator]').forEach((indicator) => {
      indicator.addEventListener('click', (event) => {
        event.preventDefault();
        const index = Number(indicator.dataset.galleryIndicator || 0);
        selectImageByIndex(ctx, index, { scrollIntoView: true });
      });
    });
  }

  function renderIndicators(ctx) {
    if (!ctx.galleryIndicators) return;
    const iconSrc = ctx.galleryIndicators.dataset.indicatorSrc || '';
    const count = Array.isArray(ctx.galleryImages) ? ctx.galleryImages.length : 0;
    if (!count || !iconSrc) {
      ctx.galleryIndicators.innerHTML = '';
      ctx.galleryIndicators.hidden = true;
      return;
    }

    ctx.galleryIndicators.hidden = count <= 1;
    ctx.galleryIndicators.innerHTML = ctx.galleryImages
      .map((_, index) => {
        const isActive = index === ctx.activeImageIndex ? ' gallery-indicator--active' : '';
        return `
          <button class="gallery-indicator${isActive}" type="button" data-gallery-indicator="${index}" aria-label="View image ${index + 1}">
            <img src="${iconSrc}" alt="" loading="lazy" decoding="async">
          </button>
        `;
      })
      .join('');
    bindIndicatorClicks(ctx);
  }

  function handleThumbInteraction(ctx, button, options = {}) {
    if (!button || !ctx.mainImage || !ctx.galleryThumbnails) return;
    const image = button.dataset.image;
    if (!image) return;

    ctx.galleryThumbnails
      .querySelectorAll(SELECTORS.galleryThumb)
      .forEach((thumb) => thumb.classList.remove(CLASSNAMES.activeThumb));

    button.classList.add(CLASSNAMES.activeThumb);
    const fullSrc = button.dataset.largeImage;
    setMainImage(ctx, image, fullSrc);

    ctx.activeImageIndex = Number(button.dataset.galleryIndex || 0);
    updateNavState(ctx);
    updateIndicatorState(ctx);

    if (options.scrollIntoView && typeof button.scrollIntoView === 'function') {
      button.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'nearest' });
    }
  }

  function selectImageByIndex(ctx, index, options = {}) {
    if (!ctx.mainImage) return;
    const selector = `${SELECTORS.galleryThumb}[data-gallery-index='${index}']`;
    const button = ctx.galleryThumbnails ? ctx.galleryThumbnails.querySelector(selector) : null;
    if (button) {
      handleThumbInteraction(ctx, button, options);
      return;
    }

    const image = Array.isArray(ctx.galleryImages) ? ctx.galleryImages[index] : null;
    if (!image) return;

    const medium = image.medium || TGLProduct.resizeShopifyImage(image.src, 800);
    const full = image.src || medium;
    setMainImage(ctx, medium, full);
    ctx.activeImageIndex = index;
    updateNavState(ctx);
    updateIndicatorState(ctx);
  }

  function renderGallery(ctx, images) {
    if (!ctx.galleryThumbnails || !ctx.mainImage || !images.length) return;

    ctx.galleryImages = images;
    ctx.activeImageIndex = 0;

    ctx.galleryThumbnails.innerHTML = images
      .map((image, index) => {
        const isActive = index === 0 ? ` ${CLASSNAMES.activeThumb}` : '';
        const thumb = image.thumb || TGLProduct.resizeShopifyImage(image.src, 150);
        const medium = image.medium || TGLProduct.resizeShopifyImage(image.src, 800);
        const full = image.src || medium;
        return `
          <button class="thumbnail-btn${isActive}" data-gallery-thumb data-gallery-index="${index}" data-image="${medium}" data-large-image="${full}" aria-label="View image ${index + 1}">
            <img src="${thumb}" alt="" class="thumbnail-image" width="150" height="187">
          </button>
        `;
      })
      .join('');

    const firstImage = images[0];
    const medium = firstImage.medium || TGLProduct.resizeShopifyImage(firstImage.src, 800);
    const full = firstImage.src || medium;
    setMainImage(ctx, medium, full);
    updateNavState(ctx);
    renderIndicators(ctx);
  }

  function navigateGallery(ctx, delta) {
    if (!Array.isArray(ctx.galleryImages) || ctx.galleryImages.length < 2) return;
    const nextIndex = (ctx.activeImageIndex + delta + ctx.galleryImages.length) % ctx.galleryImages.length;
    selectImageByIndex(ctx, nextIndex, { scrollIntoView: true });
  }

  function bindSwipe(ctx) {
    if (!ctx.galleryMain) return;
    let startX = 0;
    let startY = 0;
    let tracking = false;

    const reset = () => {
      startX = 0;
      startY = 0;
      tracking = false;
    };

    // capture the initial finger position so we can compare movement later
    ctx.galleryMain.addEventListener('touchstart', (event) => {
      if (event.touches.length !== 1) return;
      startX = event.touches[0].clientX;
      startY = event.touches[0].clientY;
      tracking = true;
    }, { passive: true });

    // on release, determine whether the horizontal movement was enough to count as a swipe
    ctx.galleryMain.addEventListener('touchend', (event) => {
      if (!tracking) return;
      const touch = event.changedTouches[0];
      const deltaX = touch.clientX - startX;
      const deltaY = touch.clientY - startY;
      const absX = Math.abs(deltaX);
      const absY = Math.abs(deltaY);

      if (absX > 40 && absX > absY) {
        if (deltaX < 0) {
          navigateGallery(ctx, 1);
        } else {
          navigateGallery(ctx, -1);
        }
      }

      reset();
    }, { passive: true });

    // ensure cleaning state if browser cancels the gesture mid-flight
    ctx.galleryMain.addEventListener('touchcancel', reset, { passive: true });
  }

  function updateGallery(ctx, variant) {
    const images = getVariantImages(ctx.data, variant);
    if (!images.length) {
      ctx.galleryImages = [];
      ctx.activeImageIndex = 0;
      updateNavState(ctx);
      if (ctx.galleryIndicators) {
        ctx.galleryIndicators.innerHTML = '';
        ctx.galleryIndicators.hidden = true;
      }
      setGalleryLoading(ctx, false);
      return;
    }
    renderGallery(ctx, images);
  }

  function bindGallery(ctx) {
    if (ctx.galleryThumbnails) {
      ctx.galleryThumbnails.addEventListener('click', (event) => {
        const button = event.target.closest(SELECTORS.galleryThumb);
        if (!button || !ctx.galleryThumbnails.contains(button)) return;
        event.preventDefault();
        handleThumbInteraction(ctx, button);
      });
    }

    if (ctx.galleryPrev) {
      ctx.galleryPrev.addEventListener('click', (event) => {
        event.preventDefault();
        navigateGallery(ctx, -1);
      });
    }

    if (ctx.galleryNext) {
      ctx.galleryNext.addEventListener('click', (event) => {
        event.preventDefault();
        navigateGallery(ctx, 1);
      });
    }

    bindSwipe(ctx);
    updateNavState(ctx);
    renderIndicators(ctx);
  }

  TGLProduct.updateGallery = updateGallery;
  TGLProduct.bindGallery = bindGallery;
})();
